<template>

  <div>
    <Company v-if="activeName == 'company'"></Company>
    <Statistic v-if="activeName == 'statistic'"></Statistic>
  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Company from './company_list';
import Statistic from './statistic';

export default {
  components: {
    Company,
    Statistic,
  },
  data() {
    return {
      formInline: {
        nick_name: ''
      },
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'company',
      /*切换数组*/
      sourceList: [
        {
          key: 'company',
          value: '列表',
          path:'/plus/company/company_list'
        },
        {
          key: 'statistic',
          value: '统计',
          path:'/plus/company/statistic'
        },
      ],
      /*权限筛选后的数据*/
      tabList:[],
      /*判断third是否有参数*/
      is_third_param: false
    };
  },
  watch:{
    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type:'company',list: [] });
    bus.$off('activeValue');
  },
  methods: {
    /*初始化方法*/
    init(){
      this.tabList=this.authFilter();
      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }
      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }
      /*监听传插件的值*/
      bus.$on('activeValue', res => {
        if (this.is_third_param) {
          this.param.user_id = '';
          this.is_third_param = false;
        }
        this.activeName = res;
      });
      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type:'company'
      };
      bus.$emit('tabData', params);
    },

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/company/index.vue